import React from "react"
import { ITimeTotals } from "../../../models"
import strings from "../../../localization/strings"
import _ from "lodash"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import { FontIcon } from "material-ui"
import { ITimeTotalBudgetItem } from "../../../models/data/TimeTotalBudgetItem"
import { green500, red500 } from "material-ui/styles/colors"
import AccountStore from "../../../stores/AccountStore"

interface IProps {
    consolidatedTimecardTimeSummary: ITimeTotals
}

const BudgetTimeSummaryTable: React.SFC<IProps> = (props: IProps) => {
    const getPayTypeName = (row: ITimeTotalBudgetItem) => {
        if (row.RegularTime) {
            return "REG"
        } else if (row.OTTime) {
            return "OT"
        } else if (row.OT2Time) {
            return "OT2"
        } else {
            return row.PayTypeName
        }
    }

    const getVarianceIcon = (variance: number) => {
        if (variance == 0) {
            return null
        } else if (variance > 0) {
            return (
                <FontIcon className="fa fa-arrow-down" style={{ fontSize: 12, color: green500 }} />
            )
        } else {
            return (
                <FontIcon className="fa fa-arrow-up" style={{ fontSize: 12, color: red500 }} />
            )
        }
    }

    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    const budgetItemsCount = props.consolidatedTimecardTimeSummary.BudgetItems ? props.consolidatedTimecardTimeSummary.BudgetItems.length : 0
    return (
        <Table>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                {budgetItemsCount > 0 ?
                    <TableRow>
                        <TableHeaderColumn style={{ textAlign: "left", width: 75 }} >{strings.Pay_Type}</TableHeaderColumn>
                        <TableHeaderColumn style={{ textAlign: "left", width: 75 }} >{strings.Hours}</TableHeaderColumn>
                        <TableHeaderColumn style={{ textAlign: "left", width: 75 }} >{strings.BudgetedHours}</TableHeaderColumn>
                        <TableHeaderColumn style={{ textAlign: "left", width: 100 }} >{strings.VarianceHours}</TableHeaderColumn>
                        <TableHeaderColumn style={{ textAlign: "left", width: 100 }} >{strings.Amount}</TableHeaderColumn>
                        <TableHeaderColumn style={{ textAlign: "left", width: 100 }} >{strings.BudgetedAmount}</TableHeaderColumn>
                        <TableHeaderColumn style={{ textAlign: "left", width: 100 }} >{strings.VarianceAmount}</TableHeaderColumn>
                    </TableRow> :
                    <TableRow>
                        <TableHeaderColumn style={{ textAlign: "left", width: 75 }} >{strings.Pay_Type}</TableHeaderColumn>
                        <TableHeaderColumn style={{ textAlign: "left", width: 75 }} >{strings.RegularHours}</TableHeaderColumn>
                        <TableHeaderColumn style={{ textAlign: "left", width: 75 }} >{strings.OvertimeHours}</TableHeaderColumn>
                        {!AccountStore.getHideOT2() &&
                            <TableHeaderColumn style={{ textAlign: "left", width: 75 }} >{strings.DoubleOvertimeHours}</TableHeaderColumn>
                        }
                        <TableHeaderColumn style={{ textAlign: "left", width: 75 }} >{strings.TotalHours}</TableHeaderColumn>
                        <TableHeaderColumn style={{ textAlign: "left", width: 100 }} >{strings.Amount}</TableHeaderColumn>
                    </TableRow>
                }
            </TableHeader>
            {budgetItemsCount > 0 ?
                <TableBody showRowHover deselectOnClickaway displayRowCheckbox={false}>
                    {props.consolidatedTimecardTimeSummary.BudgetItems.map((budgetItem, index) =>
                        <TableRow data-intercom-target={`Select${index}`} key={index} >
                            <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                                {getPayTypeName(budgetItem)}
                            </TableRowColumn>
                            <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                                {!budgetItem.OnlyAmount && budgetItem.ActualHours}
                            </TableRowColumn>
                            <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                                {!budgetItem.OnlyAmount && budgetItem.BudgetedHours}
                            </TableRowColumn>
                            <TableRowColumn style={{ textAlign: "left", width: 100 }}>
                                {!budgetItem.OnlyAmount && getVarianceIcon(budgetItem.HoursVariance)} {!budgetItem.OnlyAmount && budgetItem.HoursVariance}
                            </TableRowColumn>
                            <TableRowColumn style={{ textAlign: "left", width: 100 }}>
                                {formatter.format(budgetItem.ActualAmount)}
                            </TableRowColumn>
                            <TableRowColumn style={{ textAlign: "left", width: 100 }}>
                                {formatter.format(budgetItem.BudgetedAmount)}
                            </TableRowColumn>
                            <TableRowColumn style={{ textAlign: "left", width: 100 }}>
                                {getVarianceIcon(budgetItem.AmountVariance)} {formatter.format(budgetItem.AmountVariance)}
                            </TableRowColumn>
                        </TableRow>
                    )}
                    <TableRow data-intercom-target={`Select${budgetItemsCount + 1}`} key={budgetItemsCount + 1} >
                        <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                            <b>{strings.Total}</b>
                        </TableRowColumn>
                        <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                            <b>{props.consolidatedTimecardTimeSummary.TotalBudget.ActualHours}</b>
                        </TableRowColumn>
                        <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                            <b>{props.consolidatedTimecardTimeSummary.TotalBudget.BudgetedHours}</b>
                        </TableRowColumn>
                        <TableRowColumn style={{ textAlign: "left", width: 100 }}>
                            {getVarianceIcon(props.consolidatedTimecardTimeSummary.TotalBudget.HoursVariance)} <b>{props.consolidatedTimecardTimeSummary.TotalBudget.HoursVariance}</b>
                        </TableRowColumn>
                        <TableRowColumn style={{ textAlign: "left", width: 100 }}>
                            <b>{formatter.format(props.consolidatedTimecardTimeSummary.TotalBudget.ActualAmount)}</b>
                        </TableRowColumn>
                        <TableRowColumn style={{ textAlign: "left", width: 100 }}>
                            <b>{formatter.format(props.consolidatedTimecardTimeSummary.TotalBudget.BudgetedAmount)}</b>
                        </TableRowColumn>
                        <TableRowColumn style={{ textAlign: "left", width: 100 }}>
                            {getVarianceIcon(props.consolidatedTimecardTimeSummary.TotalBudget.AmountVariance)} <b>{formatter.format(props.consolidatedTimecardTimeSummary.TotalBudget.AmountVariance)}</b>
                        </TableRowColumn>
                    </TableRow>
                    {props.consolidatedTimecardTimeSummary.PayTypeBudgetItems && props.consolidatedTimecardTimeSummary.PayTypeBudgetItems.length > 0 &&
                        <TableRow style={{ height: 15 }} />
                    }
                    {props.consolidatedTimecardTimeSummary.PayTypeBudgetItems && props.consolidatedTimecardTimeSummary.PayTypeBudgetItems.length > 0 &&
                        props.consolidatedTimecardTimeSummary.PayTypeBudgetItems.map((budgetItem, index) =>
                            <TableRow data-intercom-target={`SelectPayType${index}`} key={`PayType${index}`} >
                                <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                                    <b>{budgetItem.PayTypeName}</b>
                                </TableRowColumn>
                                <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                                    <b>{budgetItem.ActualHours}</b>
                                </TableRowColumn>
                                <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                                    <b>{budgetItem.BudgetedHours}</b>
                                </TableRowColumn>
                                <TableRowColumn style={{ textAlign: "left", width: 100 }}>
                                    {getVarianceIcon(budgetItem.HoursVariance)} <b>{budgetItem.HoursVariance}</b>
                                </TableRowColumn>
                                <TableRowColumn style={{ textAlign: "left", width: 100 }}>
                                    <b>{formatter.format(budgetItem.ActualAmount)}</b>
                                </TableRowColumn>
                                <TableRowColumn style={{ textAlign: "left", width: 100 }}>
                                    <b>{formatter.format(budgetItem.BudgetedAmount)}</b>
                                </TableRowColumn>
                                <TableRowColumn style={{ textAlign: "left", width: 100 }}>
                                    {getVarianceIcon(budgetItem.AmountVariance)} <b>{formatter.format(budgetItem.AmountVariance)}</b>
                                </TableRowColumn>
                            </TableRow>
                        )
                    }
                </TableBody> :
                <TableBody showRowHover deselectOnClickaway displayRowCheckbox={false}>
                    {(() => {
                        const uniquePayTypeTotals = _.uniqBy([...(props.consolidatedTimecardTimeSummary.ProductiveTimePayTypeTotals || []), ...(props.consolidatedTimecardTimeSummary.PayTypeTotals || [])], "PayTypeId")
                        return uniquePayTypeTotals.map((item, index) =>
                            <TableRow data-intercom-target={`Select${index}`} key={index} >
                                <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                                    {item.PayTypeName}
                                </TableRowColumn>
                                <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                                    {item.TotalRegHours}
                                </TableRowColumn>
                                <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                                    {item.TotalOTHours}
                                </TableRowColumn>
                                {!AccountStore.getHideOT2() &&
                                    <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                                        {item.TotalOT2Hours}
                                    </TableRowColumn>
                                }
                                <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                                    {item.TotalHours}
                                </TableRowColumn>
                                <TableRowColumn style={{ textAlign: "left", width: 100 }}>
                                    {formatter.format(item.TotalPay)}
                                </TableRowColumn>
                            </TableRow>
                        )
                    })()}
                    <TableRow data-intercom-target={`SelectTotal`} key={"Total"} >
                        <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                            <b>{strings.Total}</b>
                        </TableRowColumn>
                        <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                            <b>{props.consolidatedTimecardTimeSummary.RegularHours}</b>
                        </TableRowColumn>
                        <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                            <b>{props.consolidatedTimecardTimeSummary.OvertimeHours}</b>
                        </TableRowColumn>
                        {!AccountStore.getHideOT2() &&
                            <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                                <b>{props.consolidatedTimecardTimeSummary.DoubleOvertimeHours}</b>
                            </TableRowColumn>
                        }
                        <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                            <b>{props.consolidatedTimecardTimeSummary.TotalHours}</b>
                        </TableRowColumn>
                        <TableRowColumn style={{ textAlign: "left", width: 100 }}>
                            <b>{formatter.format(props.consolidatedTimecardTimeSummary.TotalPay)}</b>
                        </TableRowColumn>
                    </TableRow>
                </TableBody>
            }
        </Table>
    )
}

export default BudgetTimeSummaryTable